// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  color: #108757 !important; }

.MuiInputBase-formControl,
.MuiButton-root {
  border-radius: 0px !important; }

.MuiFormHelperText-root {
  margin-left: 0px !important; }

.MuiButton-root {
  text-transform: none !important; }

header {
  box-shadow: none !important; }

.MuiFormControl-root.zws fieldset legend {
  width: 0px !important; }

.ant-steps-vertical > .ant-steps-item .ant-steps-item-content {
  min-height: 70px !important; }

.ant-modal-title {
  text-align: center; }

body {
  line-height: 1.5;
  font-size: 15px;
  font-family: "Montserrat", sans-serif !important;
  background-color: #fafafa !important;
  color: #646464 !important; }

.legal-notice p, li, .terms p {
  font-size: 18px;
  font-weight: 600;
  color: #4f4f4f;
  margin-bottom: 20px; }

.terms h1, div > h2 {
  font-size: 25px;
  color: #108757;
  margin: 20px auto; }

.legal-notice h2 {
  font-size: 40px;
  color: #108757;
  margin: 20px auto; }

.poppins {
  font-family: 'Poppins', sans-serif !important; }

.small {
  font-size: 12px; }

h1,
h2,
h3,
h4 {
  font-weight: bold !important; }

.pointer {
  cursor: pointer; }

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; }

/* Firefox */
input[type=number] {
  -moz-appearance: textfield; }

.react-datepicker {
  border: none;
  font-family: "Montserrat", sans-serif;
  font-weight: 500; }

.react-datepicker__day--selected, .react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range {
  background-color: #108758;
  color: #fff;
  border-radius: 100%; }

.react-datepicker__header {
  background-color: #fff; }

.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover {
  border-radius: 100%; }

.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
  border-radius: 100%; }

.fc-scrollgrid-sync-inner a {
  color: #000; }

.fc-col-header {
  background-color: #aacebf; }

.fc .fc-button-primary {
  background-color: #108758;
  border-color: #108758;
  color: #fff; }

.fc .fc-button-primary:hover {
  background-color: #7bb89f;
  border-color: #7bb89f;
  color: #fff; }

.fc .fc-button-primary:disabled {
  background-color: #aacebf;
  border-color: #aacebf;
  color: #024402;
  font-weight: 500; }

.table_ {
  min-width: 100%;
  text-align: center; }

.table_ thead th {
  background-color: #b1d8c8;
  color: #000; }

.table_ thead tr:nth-child(1) th {
  background-color: #fff;
  color: #000; }

.table_operation .table_ thead tr:nth-child(1) th:nth-child(6) {
  background-color: #b1d8c8;
  color: #000; }

.table_cachier thead tr:nth-child(1) th:nth-child(6), .table_cachier thead tr:nth-child(1) th:nth-child(7) {
  background-color: #b1d8c8;
  color: #000; }

.table_stock thead tr:nth-child(1) th:nth-child(4), .table_stock thead tr:nth-child(1) th:nth-child(5) {
  background-color: #b1d8c8;
  color: #000; }

.table_ .tr_head {
  border: 5px solid #fff; }

.table_ .tr_head th {
  border-left: 5px solid #fff;
  border-right: 5px solid #fff; }

.table_ .td_ {
  border-left: 5px solid #fff;
  border-right: 5px solid #fff; }

.tr_child {
  border: 1px solid #dddada; }

.tr_child td, .tr_child th {
  border-left: 1px solid #dddada;
  border-bottom: 1px solid #dddada !important;
  border-right: 1px solid #dad9d9 !important;
  font-size: 9pt; }

.table_ .tr_ {
  border: 5px solid #fff;
  margin-top: 10px;
  background: #f8f8f8; }

.mutliDateInput {
  min-width: 280px;
  border: none; }

.campaign .react-datepicker {
  border: 1px solid #ddd; }

.campaign .react-datepicker__navigation {
  border: none;
  padding-top: 12px; }

.campaign .react-datepicker__year-text, .campaign .react-datepicker__year-text:hover {
  border-radius: 0px; }

.mutliDateInput input[type="text"] {
  min-width: 250px;
  background: none; }

.campaign input[type="text"] {
  font-size: 14pt;
  background: none;
  font-weight: bold; }

.cachier_datepicker button {
  margin-top: 7px;
  border: none; }

.react-datepicker__close-icon::after {
  background-color: #108758; }

.react-datepicker__input-container {
  padding: 10px; }

.react-datepicker-wrapper {
  border: 1px solid #ddd; }

.campaign_select .ant-select-selector {
  background: antiquewhite; }

.multiSelectContainer .optionListContainer .option:hover, .multiSelectContainer .optionListContainer .option:active, .multiSelectContainer .highlightOption {
  background: #108758;
  color: #fff !important; }

.multiSelectContainer .searchWrapper {
  border: 1px solid #ccc;
  border-radius: 0px;
  min-height: 46px;
  min-width: 250px;
  padding: 5px;
  position: relative; }

.multiSelectContainer {
  margin-left: 10px;
  margin-right: 10px; }

.css-mta8o9-MuiPaper-root {
  margin-bottom: 10px; }

.optionListContainer .option {
  font-size: 10pt;
  margin-bottom: 0; }

body > iframe {
  display: none; }

.rbc-calendar {
  height: 700px !important; }

.rbc-event, .rbc-day-slot .rbc-background-event {
  padding: 0px !important; }

.react-datepicker__month .react-datepicker__month-text, .react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
  height: 4rem;
  line-height: 4rem; }

.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  border-radius: 100%; }

.react-datepicker__day--keyboard-selected:hover, .react-datepicker__month-text--keyboard-selected:hover, .react-datepicker__quarter-text--keyboard-selected:hover, .react-datepicker__year-text--keyboard-selected:hover {
  background-color: #108757;
  color: #fff; }

.rbc-event-label {
  display: none; }

.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event {
  min-height: 50px; }

.rbc-day-slot .rbc-event-content {
  min-width: 200px; }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/variables.scss","webpack://./src/assets/scss/mui.scss","webpack://./src/assets/scss/antd.scss","webpack://./src/assets/scss/custom.scss"],"names":[],"mappings":"AAGA;EACI,yBAA0B,EAAA;;ACJ9B;;EAEE,6BAA6B,EAAA;;AAG/B;EACE,2BAA2B,EAAA;;AAG7B;EACE,+BAA+B,EAAA;;AAkBjC;EACE,2BAA2B,EAAA;;AAG7B;EACE,qBAAqB,EAAA;;ACjCvB;EACI,2BAA2B,EAAA;;AAG/B;EACI,kBAAkB,EAAA;;ACEtB;EACI,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oCAAoC;EACpC,yBAAyB,EAAA;;AAG7B;EACI,eAAe;EACf,gBAAe;EACf,cAAc;EACd,mBAAmB,EAAA;;AAGvB;EACI,eAAe;EACf,cAAc;EACd,iBAAiB,EAAA;;AAGrB;EACI,eAAe;EACf,cAAc;EACd,iBAAiB,EAAA;;AAGrB;EACI,6CAA6C,EAAA;;AAGjD;EACI,eAAe,EAAA;;AAGnB;;;;EAII,4BAA4B,EAAA;;AAGhC;EACI,eAAe,EAAA;;AAGnB,gCAAA;AACA;;EAEI,wBAAwB;EACxB,SAAS,EAAA;;AAGb,YAAA;AACA;EACI,0BAA0B,EAAA;;AAE9B;EACI,YAAY;EACZ,qCAAqC;EACrC,gBAAgB,EAAA;;AAEpB;EACI,yBAAyB;EACzB,WAAW;EACX,mBAAmB,EAAA;;AAEvB;EACI,sBAAsB,EAAA;;AAE1B;EACI,mBAAmB,EAAA;;AAEvB;EACI,WAAW;EACX,iBAAiB;EACjB,mBAAmB,EAAA;;AAEvB;EACI,WAAW,EAAA;;AAEf;EACI,yBAAyB,EAAA;;AAE7B;EACI,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAA;;AAEf;EACI,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAA;;AAEf;EACI,yBAAyB;EACzB,qBAAqB;EACrB,cAAoB;EACpB,gBAAgB,EAAA;;AAEpB;EACI,eAAe;EACf,kBAAkB,EAAA;;AAEtB;EACI,yBAAyB;EACzB,WAAW,EAAA;;AAGf;EACI,sBAAsB;EACtB,WAAW,EAAA;;AAGf;EACI,yBAAyB;EACzB,WAAW,EAAA;;AAEf;EACI,yBAAyB;EACzB,WAAW,EAAA;;AAGf;EACI,yBAAyB;EACzB,WAAW,EAAA;;AAEf;EACI,sBAAsB,EAAA;;AAG1B;EACI,2BAA2B;EAC3B,4BAA4B,EAAA;;AAGhC;EACI,2BAA2B;EAC3B,4BAA4B,EAAA;;AAEhC;EACI,yBAAyB,EAAA;;AAE7B;EACI,8BAA8B;EAC9B,2CAA0C;EAC1C,0CAA0C;EAC1C,cAAc,EAAA;;AAElB;EACI,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB,EAAA;;AAGvB;EACI,gBAAgB;EAChB,YAAW,EAAA;;AAEf;EACG,sBAAsB,EAAA;;AAEzB;EACG,YAAY;EACZ,iBAAiB,EAAA;;AAEpB;EACG,kBAAkB,EAAA;;AAErB;EACI,gBAAgB;EAChB,gBAAgB,EAAA;;AAEpB;EACG,eAAc;EACb,gBAAgB;EAChB,iBAAiB,EAAA;;AAErB;EACI,eAAe;EACf,YAAY,EAAA;;AAEhB;EACI,yBAAyB,EAAA;;AAE7B;EACI,aAAY,EAAA;;AAEhB;EACI,sBACJ,EAAA;;AAEA;EACG,wBAAwB,EAAA;;AAG3B;EACI,mBAAmB;EACnB,sBAAqB,EAAA;;AAGzB;EACI,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB,EAAA;;AAEtB;EACI,iBAAiB;EACjB,kBAAkB,EAAA;;AAGtB;EACI,mBAAmB,EAAA;;AAEvB;EACI,eAAe;EACf,gBAAgB,EAAA;;AAEpB;EACI,aAAa,EAAA;;AAEf;EACE,wBAAuB,EAAA;;AAE1B;EACG,uBAAsB,EAAA;;AAGzB;EACG,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAErB;EACI,mBAAmB,EAAA;;AAEvB;EACI,yBAAyB;EACzB,WAAW,EAAA;;AAEf;EACI,aAAa,EAAA;;AAEjB;EACI,gBAAgB,EAAA;;AAEpB;EACI,gBAAgB,EAAA","sourcesContent":["$primary: #108757;\n$secondary: #979797;\n\n.primary {\n    color: $primary !important;\n}",".MuiInputBase-formControl,\n.MuiButton-root {\n  border-radius: 0px !important;\n}\n\n.MuiFormHelperText-root {\n  margin-left: 0px !important;\n}\n\n.MuiButton-root {\n  text-transform: none !important;\n\n  // &.MuiButton-sizeLarge {\n  //     font-size: 17px !important;\n  //     padding: 10px 30px !important;\n  // }\n\n  // &.MuiButton-outlinedSuccesss {\n  //     color: $primary !important;\n  //     border-color: $primary !important;\n  // }\n\n  // &.MuiButton-outlinedSecondarys {\n  //     color: $secondary !important;\n  //     border-color: $secondary !important;\n  // }\n}\n\nheader {\n  box-shadow: none !important;\n}\n\n.MuiFormControl-root.zws fieldset legend {\n  width: 0px !important;\n}\n",".ant-steps-vertical>.ant-steps-item .ant-steps-item-content {\n    min-height: 70px !important;\n}\n\n.ant-modal-title {\n    text-align: center;\n}","@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n@import './variables.scss';\n@import './mui.scss';\n@import './antd.scss';\n\nbody {\n    line-height: 1.5;\n    font-size: 15px;\n    font-family: \"Montserrat\", sans-serif !important;\n    background-color: #fafafa !important;\n    color: #646464 !important;\n}\n\n.legal-notice p, li, .terms p{\n    font-size: 18px;\n    font-weight:600;\n    color: #4f4f4f;\n    margin-bottom: 20px;\n}\n\n.terms h1, div > h2 {\n    font-size: 25px;\n    color: #108757;\n    margin: 20px auto;\n}\n\n.legal-notice h2 {\n    font-size: 40px;\n    color: #108757;\n    margin: 20px auto;\n}\n\n.poppins {\n    font-family: 'Poppins', sans-serif !important;\n}\n\n.small {\n    font-size: 12px;\n}\n\nh1,\nh2,\nh3,\nh4 {\n    font-weight: bold !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n.react-datepicker{\n    border: none;\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: 500;\n}\n.react-datepicker__day--selected,.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range{\n    background-color: #108758;\n    color: #fff;\n    border-radius: 100%;\n}\n.react-datepicker__header{\n    background-color: #fff;\n}\n.react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover, .react-datepicker__year-text:hover{\n    border-radius: 100%;\n}\n.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{\n    width: 3rem;\n    line-height: 3rem;\n    border-radius: 100%;\n}\n.fc-scrollgrid-sync-inner a{\n    color: #000;\n}\n.fc-col-header {\n    background-color: #aacebf;\n}\n.fc .fc-button-primary{\n    background-color: #108758;\n    border-color: #108758;\n    color: #fff;\n}\n.fc .fc-button-primary:hover{\n    background-color: #7bb89f;\n    border-color: #7bb89f;\n    color: #fff;\n}\n.fc .fc-button-primary:disabled{\n    background-color: #aacebf;\n    border-color: #aacebf;\n    color: rgb(2, 68, 2);\n    font-weight: 500;\n}\n.table_{\n    min-width: 100%;\n    text-align: center;\n}\n.table_ thead th{\n    background-color: #b1d8c8;    \n    color: #000;\n\n}\n.table_ thead tr:nth-child(1) th{\n    background-color: #fff;\n    color: #000;\n}\n\n.table_operation .table_ thead tr:nth-child(1) th:nth-child(6){\n    background-color: #b1d8c8;    \n    color: #000;\n}\n.table_cachier thead tr:nth-child(1) th:nth-child(6),.table_cachier thead tr:nth-child(1) th:nth-child(7){\n    background-color: #b1d8c8;    \n    color: #000;\n}\n\n.table_stock thead tr:nth-child(1) th:nth-child(4),.table_stock thead tr:nth-child(1) th:nth-child(5){\n    background-color: #b1d8c8;    \n    color: #000;\n}\n.table_ .tr_head{\n    border: 5px solid #fff;\n}\n\n.table_ .tr_head th{\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n}\n\n.table_ .td_{\n    border-left: 5px solid #fff;\n    border-right: 5px solid #fff;\n}\n.tr_child{\n    border: 1px solid #dddada;\n}\n.tr_child td, .tr_child th{\n    border-left: 1px solid #dddada;\n    border-bottom: 1px solid #dddada!important;\n    border-right: 1px solid #dad9d9 !important;\n    font-size: 9pt;\n}\n.table_ .tr_{\n    border: 5px solid #fff;\n    margin-top: 10px;\n    background: #f8f8f8;\n}\n\n.mutliDateInput{\n    min-width: 280px;\n    border:none;\n}\n.campaign .react-datepicker{\n   border: 1px solid #ddd;\n}\n.campaign .react-datepicker__navigation{\n   border: none;\n   padding-top: 12px;\n}\n.campaign .react-datepicker__year-text,.campaign .react-datepicker__year-text:hover{\n   border-radius: 0px;\n}\n.mutliDateInput input[type=\"text\"]{\n    min-width: 250px;\n    background: none;\n}\n.campaign input[type=\"text\"]{\n   font-size:14pt;\n    background: none;\n    font-weight: bold;\n}\n.cachier_datepicker button{\n    margin-top: 7px;\n    border: none;\n}\n.react-datepicker__close-icon::after{\n    background-color: #108758;\n}\n.react-datepicker__input-container{\n    padding:10px;\n}\n.react-datepicker-wrapper{\n    border:1px solid #ddd\n}\n\n.campaign_select .ant-select-selector{\n   background: antiquewhite;\n}\n\n.multiSelectContainer .optionListContainer .option:hover, .multiSelectContainer .optionListContainer .option:active,.multiSelectContainer .highlightOption{\n    background: #108758;\n    color: #fff!important;\n}\n\n.multiSelectContainer .searchWrapper {\n    border: 1px solid #ccc;\n    border-radius: 0px; \n    min-height: 46px;\n    min-width: 250px;\n    padding: 5px;\n    position: relative;\n}\n.multiSelectContainer{\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.css-mta8o9-MuiPaper-root{\n    margin-bottom: 10px;\n}\n.optionListContainer .option{\n    font-size: 10pt;\n    margin-bottom: 0;\n}\nbody > iframe {\n    display: none;\n  }\n  .rbc-calendar {\n    height: 700px!important;\n }\n .rbc-event, .rbc-day-slot .rbc-background-event{\n    padding: 0px!important;\n }\n\n .react-datepicker__month .react-datepicker__month-text, .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n    height: 4rem;\n    line-height: 4rem;\n}\n.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected{\n    border-radius: 100%;\n}\n.react-datepicker__day--keyboard-selected:hover, .react-datepicker__month-text--keyboard-selected:hover, .react-datepicker__quarter-text--keyboard-selected:hover, .react-datepicker__year-text--keyboard-selected:hover{\n    background-color: #108757;\n    color: #fff;\n}\n.rbc-event-label{\n    display: none;\n}\n.rbc-day-slot .rbc-event, .rbc-day-slot .rbc-background-event{\n    min-height: 50px;\n}\n.rbc-day-slot .rbc-event-content{\n    min-width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
